import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Button from '@mui/material/Button';

import { useLocalStorage } from "../components/useLocalStorage";
import { useNavigate, Outlet, Link } from "react-router-dom";

const AppBoardScreen = () => {
    const [WouldLikeRemoveSuspensionHidden, setWouldLikeRemoveSuspensionHidden] = useLocalStorage("WouldLikeRemoveSuspensionHidden", "");
    const navigate = useNavigate();
    return (
        <Box id="AppBoardScreen2" className="AppBoardScreen AppBoardScreen2" sx={{ width: 800, m: "auto",  backgroundColor: '#fefefe', p: 6.25 }}>
             <input type="hidden" value={WouldLikeRemoveSuspensionHidden} />
            <Grid container spacing={2} sx={{ textAlign: "center" }}>
                <Grid item xs={12} sx={{ textAlign: "left" }}>
                    <Link to="/dmv/cambio/NameVin">
                        <Button variant="outlined" size="large">Regresar</Button>
                    </Link>
                </Grid>
                <Grid item xs={12}>
                    <h2 className="subHeading">¿Por cuánto compraste el vehículo?</h2>
                </Grid>
                <Grid item xs={12}>           
                    <Button onClick={ () => { setWouldLikeRemoveSuspensionHidden("Yes"); setTimeout(() => { navigate("/dmv/cambio/IsVehicleRegisteredStateCalifornia")}, 100) }} variant="contained" color="success" size="large" sx={{ width: "50%" }}>$</Button>
                </Grid>
                <Grid item xs={12}>                 
                    <Button onClick={ () => { setWouldLikeRemoveSuspensionHidden("No"); setTimeout(() => { navigate("/dmv/cambio/WouldYouLikeGet")}, 100) }} variant="contained" color="error" size="large" sx={{ width: "50%" }}>Cancelar</Button>
                </Grid>
                
                <Outlet/>
            </Grid>
        </Box>
    );
};

export default AppBoardScreen;